var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.486 3.332l.988-.989c.42-.419 1.096-.419 1.51 0l8.66 8.655c.418.418.418 1.096 0 1.51l-8.66 8.659c-.418.419-1.095.419-1.51 0l-.988-.989c-.424-.423-.415-1.113.017-1.528l5.368-5.113H3.069c-.592 0-1.069-.477-1.069-1.07v-1.425c0-.592.477-1.069 1.069-1.069h12.802L10.503 4.86c-.436-.415-.445-1.105-.017-1.528z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9bf1db285d7cd0aeb488f064a0d1163d.svg";
export { ForwardRef as ReactComponent };